/*
 * Copyright (c) 2020 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('member.dinghy-booking', {
            parent: 'member',
            url: '/member/dinghy-booking?archive',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'askApp.booking.home.title3'
            },
            views: {
                'content@': {
                    templateUrl: 'app/member/dinghy-booking/dinghy-bookings.html',
                    controller: 'MemberDinghyBookingController',
                    controllerAs: 'vm'
                }
            },
            params: {
                archive: {
                    value: 'false',
                    squash: true
                }
            },
            resolve: {
                pagingParams: ['$stateParams', function ($stateParams) {
                    return {
                        archive: $stateParams.archive
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('dinghyBooking');
                    $translatePartialLoader.addPart('dinghyEvent');
                    $translatePartialLoader.addPart('dept');
                    $translatePartialLoader.addPart('enumDinghyEventType');
                    $translatePartialLoader.addPart('enumBookingStatusType');
                    $translatePartialLoader.addPart('enumDeptStatus');
                    return $translate.refresh();
                }]
            }
        })
        .state('member.dinghy-booking.book', {
            parent: 'member.dinghy-booking',
            url: '/book/{id}',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/member/dinghy-events/dinghy-booking-dialog.html',
                    controller: 'MemberDinghyBookingDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        entity: ['DinghyBookingMember', function(DinghyBookingMember) {
                            return DinghyBookingMember.get({id : $stateParams.id}).$promise;
                        }],
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('booking');
                            return $translate.refresh();
                        }]
                    }
                }).result.then(function() {
                    $state.go('member.dinghy-booking', null, { reload: 'member.dinghy-booking' });
                }, function() {
                    $state.go('member.dinghy-booking');
                });
            }]
        })
        .state('member.dinghy-booking.change', {
            parent: 'member.dinghy-booking',
            url: '/change/{id}',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/member/dinghy-events/dinghy-booking-change-dialog.html',
                    controller: 'MemberDinghyBookingChangeController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        entity: ['DinghyBookingDetailMember', function(DinghyBookingDetailMember) {
                            return DinghyBookingDetailMember.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function(result) {
                    $state.go('member.dinghy-booking', null, { reload: 'member.dinghy-booking' });
                }, function() {
                    $state.go('member.dinghy-booking');
                });
            }]
        })
        .state('member.dinghy-booking.detail', {
            parent: 'member.dinghy-booking',
            url: '/detail/{id}',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/member/dinghy-events/dinghy-booking-detail-dialog.html',
                    controller: 'MemberDinghyBookingDetailDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        entity: ['DinghyBookingDetailMember', function(DinghyBookingDetailMember) {
                            return DinghyBookingDetailMember.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('member.dinghy-booking', null, { reload: 'member.dinghy-booking' });
                }, function() {
                    $state.go('member.dinghy-booking');
                });
            }]
        });
    }
})();
